import Dialog from './proto'

export default new Dialog()
